import { render, staticRenderFns } from "./customerPricing.vue?vue&type=template&id=83781d0a&"
import script from "./customerPricing.vue?vue&type=script&lang=js&"
export * from "./customerPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports